module.exports = __webpack_public_path__ + "static/img/todaitotexas.a52b8e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/sponser/todaitotexas.jpg
// module id = XU/B
// module chunks = 0